import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useEffect, useRef } from 'react';
import ObjectSchemaApi from '../../../api/ObjectSchemaApi';
import Loader from '../../../components/Loader';
import useResourceLoader from '../../../util/useResourceLoader';

import useParentWidthResizer from './util/userParentWidthResizer';

import { Background, ReactFlow, addEdge, Panel, useNodesState, useEdgesState, useReactFlow } from '@xyflow/react';
import '@xyflow/react/dist/style.css';

import {
  DEFAULT_NODE_TYPES,
  DEFAULT_EDGE_TYPES,
  DEFAULT_EDGE_OPTIONS,
  DEFAULT_CONNECTION_LINE_STYLE,
  DefaultConnectionLine,
  getDirectedGraphLayout,
} from '.';

const DEFAULT_POSITION = { x: 0, y: 0 };

const convertAdjacencyList = (adjacencyList, dataDiagram) => {
  const nodes = [];
  const edges = [];

  for (let i = 0; i < adjacencyList.length; i += 1) {
    const nodeId = adjacencyList[i].data.id.toString();

    nodes.push({
      id: nodeId,
      data: { label: adjacencyList[i].data.name, ...dataDiagram },
      position: DEFAULT_POSITION,
      type: 'item',
    });

    for (let j = 0; j < adjacencyList[i].neighbors.length; j += 1) {
      const targetId = adjacencyList[i].neighbors[j].id.toString();
      const targetLabel = adjacencyList[i].neighbors[j].label;

      edges.push({
        id: 'e:' + nodeId + '->' + targetId,
        source: nodeId,
        target: targetId,
        label: targetLabel,
        type: 'default',
        labelStyle: { fontSize: 10 },
        // data: {},
      });
    }
  }

  return {
    ns: nodes,
    es: edges,
  };
};

function DirectedGraphDiagram({ graph, dataDiagram }) {
  // ------------------------
  // - Set height and width
  // ------------------------
  const containerRef = useRef(null);
  const [width, height] = useParentWidthResizer(containerRef);

  // -------------------------------
  // - Initialize react flow state
  // -------------------------------
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const { fitView } = useReactFlow();

  // -----------------------------------------
  // - Calculate the initial layout on mount
  // -----------------------------------------
  useEffect(() => {
    if (!graph || !width || !height) return;

    const { ns, es } = convertAdjacencyList(graph.adjacencyList, dataDiagram);

    getDirectedGraphLayout(ns, es, { 'elk.aspectRatio': width / height }).then(({ nodes, edges }) => {
      setNodes(nodes);
      setEdges(edges);
      fitView();
    });
  }, [graph]);

  return (
    <div ref={containerRef} style={{ width: width, height: height }}>
      {width && height && (
        <ReactFlow
          nodes={nodes}
          edges={edges}
          defaultEdgeOptions={DEFAULT_EDGE_OPTIONS}
          nodeTypes={DEFAULT_NODE_TYPES}
          edgeTypes={DEFAULT_EDGE_TYPES}
          connectionLineComponent={DefaultConnectionLine}
          connectionLineStyle={DEFAULT_CONNECTION_LINE_STYLE}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          fitView
          nodesDraggable={false}
          nodesConnectable={false}
          edgesUpdatable={false}
          elementsSelectable={true}
          panOnDrag={true}
        >
          {/* <Panel position="top-right">
            <button className="xy-theme__button" onClick={() => console.log('TEST')}>
              Test
            </button>
          </Panel> */}
        </ReactFlow>
      )}
    </div>
  );
}

export default DirectedGraphDiagram;
